import { render, staticRenderFns } from "./AlegacionesLista.vue?vue&type=template&id=0d5d4b9c&"
import script from "./AlegacionesLista.vue?vue&type=script&lang=ts&"
export * from "./AlegacionesLista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports